import { render } from "./UsersForm.vue?vue&type=template&id=26320fd4&ts=true"
import script from "./UsersForm.vue?vue&type=script&lang=ts"
export * from "./UsersForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__